export function turkishTourPreviewLink(params) {
  // Keep the existing question-preview contract independent.
  if (params.get('preview_question_id')) return null;
  if (!params.has('preview_tour') && params.get('preview_id') !== '61') return null;
  const id = params.get('preview_id'), level = params.get('preview_level'), tour = params.get('preview_tour');
  const lastTour = { 1: 7, 2: 7, 3: 6, 4: 7, 5: 5, 6: 6 };
  if (id !== '61' || !/^[1-6]$/.test(level || '') || !/^[1-7]$/.test(tour || '')
    || Number(tour) > lastTour[level] || (level === '6' && tour !== '6')) {
    return { error: 'Önizleme bağlantısındaki içerik, level veya tur geçersiz.', key: params.toString() };
  }
  return { id: 61, level: Number(level), tour: Number(tour), key: params.toString() };
}
